import Modal from './default';
import ErrorModal from './error';
import FullscreenModal from './fullscreen';
import { ModalContent } from './content';
import type { ModalContentProps } from './content';

export { Modal, ErrorModal, FullscreenModal, ModalContent };
export type { ModalContentProps };
